export enum DashboardPermissions {
    isAllowedSeeDashboardCompany = "dashboard: company",
    isAllowedSeeDashboardCourseProgress = "dashboard: course-progresses",
    dashboardSeeDashboardDepartment = "dashboard: department",
}
